module.exports = __webpack_public_path__ + "img/5-1_06.39667fec.jpg";